import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Default Leaflet icon fix for bundlers
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";
import icon from "leaflet/dist/images/marker-icon.png";
import shadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl: icon,
  shadowUrl: shadow,
});

const CARTO_URL =
  "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png";

function MapRecenter({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (center?.lat != null && center?.lng != null) {
      map.flyTo([center.lat, center.lng], zoom ?? map.getZoom(), {
        duration: 0.8,
      });
    }
  }, [center, zoom, map]);
  return null;
}

export function createColorIcon(color) {
  return L.divIcon({
    html: `<div style="width:14px;height:14px;border-radius:50%;background:${color};border:2.5px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.3);"></div>`,
    className: "",
    iconAnchor: [7, 7],
  });
}

export default function LeafletMapView({
  center = { lat: 25.82, lng: -80.15 },
  zoom = 12,
  height = "100%",
  width = "100%",
  markers = [],
  onMarkerClick,
  flyToCenter,
  flyZoom = 15,
  className = "",
}) {
  return (
    <div style={{ height, width }} className={className}>
      <MapContainer
        center={[center.lat, center.lng]}
        zoom={zoom}
        style={{ height: "100%", width: "100%" }}
        scrollWheelZoom
      >
        <TileLayer
          attribution="© OpenStreetMap © CARTO"
          url={CARTO_URL}
          maxZoom={19}
        />
        {flyToCenter && (
          <MapRecenter center={flyToCenter} zoom={flyZoom} />
        )}
        {markers.map((m) =>
          m.lat != null && m.lng != null ? (
            <Marker
              key={m.id}
              position={[m.lat, m.lng]}
              icon={
                m.icon ||
                (m.color ? createColorIcon(m.color) : undefined)
              }
              eventHandlers={{
                click: () => onMarkerClick?.(m),
              }}
            />
          ) : null
        )}
      </MapContainer>
    </div>
  );
}
